module.exports = __webpack_public_path__ + "static/media/play-store.e503ecd6.svg";